import styled from 'styled-components';
import * as colors from '../../../../common/colorConstants';

export const MacroSourceContainer = styled.div`
  border-radius: 4px;
  background-color: ${colors.lightGray7};
  padding: 10px;
`;

export const SourceTitle = styled.span`
  font-family: Lato;
  font-weight; 500;
  margin-right: 10px;
`;

export const SourceLink = styled.a`
  margin-right: 10px;
`;
